class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = document.getElementById("back-to-top");

    if (!this.button) return;

    // Hide component initially
    this.classList.remove("active");

    // Bind methods
    this.onScroll = this.onScroll.bind(this);
    this.scrollToTop = this.scrollToTop.bind(this);

    // Add event listeners
    window.addEventListener("scroll", this.onScroll);
    this.button.addEventListener("click", this.scrollToTop);
  }

  onScroll() {
    // Show/hide component based on scroll position
    if (window.scrollY > 300) {
      this.classList.add("active");
    } else {
      this.classList.remove("active");
    }
  }

  scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScroll);
    if (this.button) {
      this.button.removeEventListener("click", this.scrollToTop);
    }
  }
}

customElements.define("back-to-top", BackToTop);
